export const employeesData = [
  {
    id: 1,
    name: "Martha Grey",
  },
  {
    id: 2,
    name: "Sammie Greg",
  },
  {
    id: 3,
    name: "Cole Whitman",
  },
  {
    id: 4,
    name: "Ada Obi",
  },
];
export const arrivalTimeData = [
  {
    id: 1,
    name: "Start timer",
  },
  {
    id: 2,
    name: "send reminder",
  },
  {
    id: 3,
    name: "don't start timer",
  },
];
export const departureTimeData = [
  {
    id: 1,
    name: "stop timer",
  },
  {
    id: 2,
    name: "send reminder",
  },
  {
    id: 3,
    name: "don't stop timer",
  },
];

export const locations = [
  {
    id: 1,
    name: "all",
  },
  {
    id: 2,
    name: "abuja",
  },
  {
    id: 3,
    name: "lagos",
  },
  {
    id: 4,
    name: "florida",
  },
  {
    id: 5,
    name: "new york",
  },
];
